<ng-container *transloco="let t; prefix: 'group-management.panels.promote-gl'">
  @if (participant(); as person) {
    <app-panel-body>
      <div class="flex min-h-0 flex-1 flex-col text-sm text-primary-text">
        <div class="min-h-0 flex-1 overflow-y-auto">
          <app-content-container>
            <div class="space-y-4">
              <p>{{ t('confirm', { name: person.firstname + ' ' + person.lastname }) }}</p>
              <p class="text-secondary-text"><em>{{ t('sign-out-warning') }}</em></p>
              <p class="text-center">
                <strong>{{ person.firstname }} {{ person.lastname }}</strong><br />
                {{ person.email }}
              </p>
            </div>
          </app-content-container>
        </div>
        <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
          <button
            type="button"
            class="rounded-md border border-primary-border bg-primary-bg px-4 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg"
            (click)="cancel()"
            [disabled]="submitting()"
          >
            {{ t('cancel') }}
          </button>
          <button
            type="button"
            class="rounded-md bg-teal px-4 py-2 text-sm font-semibold text-white hover:bg-teal-600 disabled:opacity-50"
            (click)="confirm()"
            [disabled]="submitting()"
          >
            {{ t('confirm-button') }}
          </button>
        </div>
      </div>
    </app-panel-body>
  }
</ng-container>
